import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Container, Row, Col, Card, ListGroup, Button, Table } from "react-bootstrap";
import "./img.css";
import Footer from "./footer";
import LatestUpdates from "./latestupdates";
import { link } from "framer-motion/client";

const HeroSection = () => (
  <div className="bg-light p-4 text-center">
    <h1 className="fw-bold">Working and Skilled Visas</h1>
  </div>
);

const ContentSection = () => (
  <Container>
    <h2 className="fw-bold text-decoration-underline">Overview :</h2>
    <p>
      This <strong>visa</strong> category is for those who want to apply for a Work or Business Visa. These visas include subclasses like <strong>491, 190, 482</strong>, etc.
    </p>
    <p>
      If you have skills, experience, and English proficiency, we can assist you in choosing the right visa and lodging your application.
    </p>
    <p>
      For more information, contact us, book an appointment, or fill out the enquiry form below.
    </p>
  </Container>
);

const Sidebar = () => (
  <Col md={4} className="mt-4">
    <Card className="border-0 shadow-none">
      <Card.Header className="fw-bold">Latest Posts</Card.Header>
      <ListGroup variant="flush">
        <ListGroup.Item className="border-0"><Link to="/professional">Professional Year</Link></ListGroup.Item>
        <ListGroup.Item className="border-0"><Link to="/coursechange">Admissions And Course Change</Link></ListGroup.Item>
        <ListGroup.Item className="border-0"><Link to="/skilledID">Skilled Independent Visa (Subclass 189)</Link></ListGroup.Item>
      </ListGroup>
    </Card>
  </Col>
);

const VisaPage = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const visas = [
    { subclass: "Subclass 186", visa: "Employer Nomination Scheme visa", status: "Permanently", link:"" },
// { subclass: "Subclass 891", visa: "Investor Visa", status: "Permanently" },
{ subclass: "Subclass 191", visa: "Permanent Residence (Skilled Regional) visa", status: "Permanently" },
// { subclass: "Subclass 187", visa: "Regional Sponsored Migration Scheme visa", status: "Permanently" },
{ subclass: "Subclass 494", visa: "Skilled Employer Sponsored Regional (Provisional) visa", status: "Temporary (Upto 5 Years)" },
{ subclass: "Subclass 888", visa: "Business Innovation and Investment (Permanent) visa", status: "Permanent" },
{ subclass: "Subclass 188", visa: "Business Innovation and Investment (Provisional) visa", status: "Temporary" },
// { subclass: "Subclass 890", visa: "Business Owner visa", status: "Permanent" },
// { subclass: "Subclass 132	", visa: "Business Talent (Permanent) visa", status: "Permanent" },
{ subclass: "Subclass 858", visa: "Global Talent Visa", status: "Permanent" },
{ subclass: "Subclass 189", visa: "Skilled independent visa", status: "Permanent" },
{ subclass: "Subclass 190", visa: "Skilled Nominated visa", status: "Permanent" },
// { subclass: "Subclass 476", visa: "Skilled—Recognised Graduate visa", status: "Temporary (18 Months)" },
// { subclass: "Subclass 489", visa: "Skilled Regional (Provisional) visa", status: "Temporary 4 Years" },
// { subclass: "Subclass 887", visa: "Skilled Regional visa", status: "Permanently" },
{ subclass: "Subclass 491", visa: "Skilled Work Regional (Provisional) visa", status: "Temporary 5 Years" },
// { subclass: "Subclass 892", visa: "State or Territory Sponsored Business Owner visa", status: "Permanently" },
// { subclass: "Subclass 893", visa: "State or Territory Sponsored Investor visa", status: "Permanently" },
{ subclass: "Subclass 408", visa: "Temporary Activity visa", status: "Upto 4 Years" },
{ subclass: "Subclass 485", visa: "Temporary Graduate visa", status: "Temporary" },
{ subclass: "Subclass 403", visa: "Temporary Work (International Relations) visa", status: "Upto 2 Years" },
{ subclass: "Subclass 400", visa: "Temporary Work (Short Stay Specialist) visa", status: "Temporary" },
{ subclass: "Subclass 482", visa: "Temporary Skill Shortage visa", status: "Temporary" },

  ];
  const filteredVisas = visas.filter((visa) => visa.subclass.includes(searchTerm) || visa.visa.includes(searchTerm));
  return (
    <Container className="mt-4 table-responsive">
      <h2 className="fw-bold text-center text-decoration-underline">List of Visas</h2>
      <input type="text" className="form-control my-3" placeholder="Search visas..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
      <Table bordered hover className="table">
        <thead>
          <tr>
            <th>Visa Subclass</th>
            <th>Visa</th>
            <th>Residency Status</th>
          </tr>
        </thead>
        <tbody>
          {filteredVisas.map((visa, index) => (
            <tr key={index}>
              <td>{visa.subclass}</td>
              <td>{visa.visa}</td>
              <td>{visa.status}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      <motion.button initial={{ x: "-100vw" }} animate={{ x: 0 }} className="btn btn-danger position-fixed bottom-0 stAAT-0 m-3">
        <a href="https://au.bajwaimmigration.com/book-appointment" className="text-white text-decoration-none">Consult Now</a>
      </motion.button>
    </Container>
  );
};

const WorkingAndSkilledVisas = () => (
  <>
    <HeroSection />
    <Container>
      <Row>
        <Col md={8}><ContentSection /></Col>
        <Sidebar />
      </Row>
      <VisaPage />
    </Container>
    <LatestUpdates />
    <Footer />
  </>
);

export default WorkingAndSkilledVisas;